import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';

/**
 * Confirmation dialog shown by the `pendingUploadsGuard` when a user attempts to
 * navigate away from a page that has a file selected but not yet uploaded.
 *
 * The dialog result is a boolean:
 *  - `true`  → the user confirmed they want to leave (navigation proceeds)
 *  - `false` → the user canceled (navigation is blocked)
 */
@Component({
  selector: 'eos-pending-upload-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './pending-upload-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pending-upload-dialog.component.scss',
})
export class PendingUploadDialogComponent {}
